import SpriteSymbol from "../../../../../svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../../svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "rt-base-angle-up-filled",
  "use": "rt-base-angle-up-filled-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol class=\"icon\" viewBox=\"0 0 1024 1024\" xmlns=\"http://www.w3.org/2000/svg\" id=\"rt-base-angle-up-filled\"><path d=\"M772.4 667.4L528.8 336.6c-8.4-11.5-25.1-11.5-33.5 0L251.6 667.4c-8.7 11.7-0.6 28.6 13.5 28.6H759c14 0 22-16.9 13.4-28.6z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/svg-sprite-loader/lib/loader.js?{"symbolId":"rt-base-[name]"}!./~/vue-xpc/src/assets/icons/svgs/angle-up-filled.svg
// module id = 1666
// module chunks = 137